import type { AppState, CategoryKey } from "@/types";

const CATEGORY_KEYS: CategoryKey[] = ["currency", "interest", "index"];

function isCategoryKey(value: string | null): value is CategoryKey {
  return !!value && (CATEGORY_KEYS as string[]).includes(value);
}

/** Reads whatever partial state is present in the current URL's query string. */
export function readStateFromUrl(): Partial<AppState> {
  const params = new URLSearchParams(window.location.search);
  const category = params.get("category");
  const series = params.get("series");
  const from = params.get("from");
  const to = params.get("to");

  return {
    category: isCategoryKey(category) ? category : undefined,
    series: series ?? undefined,
    from: from ?? undefined,
    to: to ?? undefined,
  };
}

/** Mirrors the resolved app state into the URL query string without pushing a new history entry. */
export function writeStateToUrl(state: AppState): void {
  const params = new URLSearchParams({
    category: state.category,
    series: state.series,
    from: state.from,
    to: state.to,
  });
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState(null, "", newUrl);
}
